// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

throw new Error(
  'The @rushstack/eslint-patch package does not have a default entry point.' +
    ' See README.md for usage instructions.'
);

export {};